import getPrivateIndexRoute from 'helpers/getPrivateIndexRoute'

import { Navigate } from 'react-router-dom'

const PrivateIndexRoute = () => {
    const role = localStorage.getItem("role") ?? ""
    return <Navigate to={getPrivateIndexRoute(role)} replace />
}

export default PrivateIndexRoute